import React from 'react';

export default function WoodenBucketSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className}>
      {/* Shadow */}
      <ellipse cx="20" cy="37" rx="10" ry="2" fill="#3E2723" opacity="0.15" />
      {/* Handle */}
      <path d="M12 12C12 4 28 4 28 12" stroke="#90A4AE" strokeWidth="2.5" strokeLinecap="round" fill="none" />
      <path d="M12 12C12 5 28 5 28 12" stroke="#B0BEC5" strokeWidth="1.5" strokeLinecap="round" fill="none" />
      {/* Handle knobs */}
      <circle cx="12" cy="12" r="1.8" fill="#90A4AE" />
      <circle cx="28" cy="12" r="1.8" fill="#90A4AE" />
      <circle cx="12" cy="11.8" r="1" fill="#B0BEC5" />
      <circle cx="28" cy="11.8" r="1" fill="#B0BEC5" />
      {/* Bucket body - tapers outward at top */}
      <path d="M10 14L8 34L32 34L30 14Z" fill="#C49A6C" />
      {/* Inner body highlight */}
      <path d="M12 16L10.5 32L29.5 32L28 16Z" fill="#D4AA7A" />
      {/* Wood plank lines */}
      <line x1="16" y1="14.5" x2="15" y2="33.5" stroke="#A67C52" strokeWidth="0.5" opacity="0.4" />
      <line x1="22" y1="14.5" x2="21.5" y2="33.5" stroke="#A67C52" strokeWidth="0.5" opacity="0.4" />
      <line x1="27" y1="14.5" x2="28" y2="33.5" stroke="#A67C52" strokeWidth="0.5" opacity="0.4" />
      {/* Top metal band */}
      <path d="M10 15L30 15L30 17L10 17Z" fill="#90A4AE" rx="0.5" />
      <path d="M10.5 15.3L29.5 15.3L29.5 16.5L10.5 16.5Z" fill="#B0BEC5" />
      {/* Bottom metal band */}
      <path d="M8.5 31L31.5 31L31.5 33L8.5 33Z" fill="#90A4AE" />
      <path d="M9 31.3L31 31.3L31 32.5L9 32.5Z" fill="#B0BEC5" />
      {/* Rim ellipse top */}
      <ellipse cx="20" cy="14" rx="10" ry="2.5" fill="#B8885A" />
      <ellipse cx="20" cy="13.7" rx="8.5" ry="1.8" fill="#C49A6C" />
      <ellipse cx="20" cy="13.5" rx="7" ry="1.2" fill="#6B4226" opacity="0.5" />
      {/* Shine */}
      <path d="M13 17C12.5 22 12.5 28 13 32" stroke="white" strokeWidth="1" strokeLinecap="round" opacity="0.15" />
    </svg>
  );
}
